import { motion } from 'motion/react';
import { Link } from 'react-router';
import { useSiteConfig } from '../utils/siteConfig';

export function GreetingPopup() {
  const { config } = useSiteConfig();
  const phoneNumber = '918155974299';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  // Get all published custom pages to show as floating buttons
  const publishedPages = config.customPages.filter(p => p.isPublished);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-3 select-none">

      {/* WhatsApp button */}
      <div className="flex flex-col items-center gap-1">
        <motion.a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="w-16 h-16 bg-[#25D366] hover:bg-[#20ba5a] text-white rounded-full flex items-center justify-center shadow-2xl hover:shadow-[#25D366]/30 cursor-pointer border border-white/20"
          initial={{ scale: 0, opacity: 0 }}
          animate={{
            scale: 1,
            opacity: 1,
            y: [0, -8, 0]
          }}
          whileHover={{ scale: 1.15 }}
          whileTap={{ scale: 0.9 }}
          transition={{
            y: {
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            },
            scale: {
              type: "spring",
              stiffness: 260,
              damping: 20
            }
          }}
          title="Chat with us on WhatsApp"
        >
          <svg viewBox="0 0 24 24" width="34" height="34" fill="currentColor">
            <path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.96 9.96 0 001.333 4.993L2 22l5.233-1.371a9.936 9.936 0 004.777 1.224h.005c5.505 0 9.989-4.478 9.99-9.985A9.983 9.983 0 0012.012 2zm5.82 14.123c-.317.892-1.547 1.636-2.137 1.748-.528.1-1.218.175-3.568-.75-2.996-1.183-4.896-4.22-5.046-4.423-.15-.203-1.2-1.595-1.2-3.042 0-1.448.75-2.157 1.018-2.447.268-.29.58-.363.774-.363.195 0 .39.002.56.01.177.008.414-.067.65.503.243.585.83 2.02.902 2.17.072.15.12.325.02.525-.1.2-.15.325-.3.5-.15.175-.315.39-.45.523-.15.132-.306.277-.132.576.175.297.777 1.282 1.666 2.073.91.81 1.674 1.06 1.96 1.208.286.147.45.123.616-.067.166-.19 1.157-1.348 1.34-1.615.183-.267.367-.223.617-.13.25.092 1.583.747 1.854.88.27.133.45.2.517.316.067.116.067.674-.25 1.566z" />
          </svg>
        </motion.a>
        <span className="text-[11px] font-bold text-slate-800 bg-white/80 backdrop-blur-sm px-2 py-0.5 rounded-full shadow-sm border border-slate-200/50">
          Quick Chat
        </span>
      </div>

      {/* Dynamic published pages as floating buttons (e.g. FAQ) */}
      {publishedPages.map((page, idx) => (
        <div key={page.id} className="flex flex-col items-center gap-1">
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{
              scale: 1,
              opacity: 1,
              y: [0, -8, 0]
            }}
            whileHover={{ scale: 1.15 }}
            whileTap={{ scale: 0.9 }}
            transition={{
              delay: 0.15 * (idx + 1),
              y: {
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 0.5 * (idx + 1)
              },
              scale: {
                type: "spring",
                stiffness: 260,
                damping: 20
              }
            }}
          >
            <Link
              to={`/page/${page.slug}`}
              className="w-16 h-16 text-white rounded-full flex items-center justify-center shadow-2xl cursor-pointer border border-white/20 font-black text-3xl"
              style={{ background: 'linear-gradient(135deg, var(--primary), var(--accent))' }}
              title={page.title}
            >
              ?
            </Link>
          </motion.div>
          <span className="text-[11px] font-bold text-slate-800 bg-white/80 backdrop-blur-sm px-2 py-0.5 rounded-full shadow-sm border border-slate-200/50">
            FAQ
          </span>
        </div>
      ))}

    </div>
  );
}
